import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Layout from "../layout/Layout";

const MenuWrapper = styled.div`
  > ul {
    @media (max-width: 991px) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 10px;
      grid-row-gap: 10px;
      .submenu {
        display: none;
      }
    }
    @media (max-width: 375px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;
const Menu = styled.li`
  & a {
    word-break: keep-all;
    height: 100%;
    display: flex;
    align-items: center;
  }
  @media (max-width: 1200px) {
    & a {
      padding: 15px 10px !important;
    }
  }
  @media (max-width: 991px) {
    :last-of-type {
      margin-bottom: 10px;
    }
    & a {
      width: 100%;
    }
  }
`;
const Wrapper = styled.div`
  @media (max-width: 991px) {
    flex-wrap: wrap;
    .dashboard-menu {
      width: 100%;
    }
  }
`;

const pathName = ["notice", "faq", "library", "contact", "b2b", "service"];
const menuIcons = [
  "megaphone",
  "exclamation",
  "cloud-download-alt",
  "headset",
  "clipboard",
  "search",
];

const sideMenus = [
  "공지사항",
  "FAQ",
  "자료 다운로드",
  "제휴 문의",
  "패키징 제안받기",
  "구해드립니다",
];

const CSBoard = ({ children }) => {
  const router = useRouter();
  const routePathName = router.pathname.split("/")[2];
  const activeIndex = pathName.indexOf(routePathName);

  const handleOnClick = (index) => {
    const url = `/csboard/${pathName[index]}`;
    router.push(url);
  };

  const pageDesc = (path) => {
    let desc = "";
    switch (path) {
      case "notice":
        desc =
          "포장재 파트너사 신규입점, 상품 신규등록 소식을 가장 먼저 만나는 곳";
        break;
      case "library":
        desc = "상품을 깊고 담백하게 이해하고 싶다면. 수시 업데이트 중";
        break;
      case "contact":
        desc =
          "입점신청, 납품, 콜라보, 콘텐츠 제휴 등 칼렛스토어의 파트너가 되어주세요";
        break;
      case "b2b":
        desc = "포장재 본격 구매, 도입하기 전에 샘플부터 써보세요";
        break;
      case "service":
        desc = "구해드립니다";
        break;
      default:
        break;
    }
    return desc;
  };

  return (
    <Layout
      parent="홈"
      sub={sideMenus[activeIndex]}
      pageTitle={sideMenus[activeIndex]}
      pageDesc={pageDesc(routePathName)}
      pageKeyword="고객센터, 칼렛스토어, 고객문의, FAQ, 자주묻는질문, 1:1문의, 주문문의, 배송문의, 교환반품, 환불절차, 이용안내, 고객지원, 문의하기"
    >
      <div className="page-content mt-50 pb-50">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 m-auto">
              <Wrapper className="row">
                <div className="col-md-2 mb-30 dashboard-menu">
                  <MenuWrapper>
                    <ul className="nav flex-column" role="tablist">
                      {sideMenus.map((el, i) => (
                        <Menu className="nav-item" key={i}>
                          <a
                            className={
                              activeIndex === i ? "nav-link active" : "nav-link"
                            }
                            onClick={() => handleOnClick(i)}
                          >
                            <div className="d-flex align-items-center">
                              <i className={`fi-rs-${menuIcons[i]} mr-10`} />
                              <span className="font-sm">{el}</span>
                            </div>
                          </a>
                        </Menu>
                      ))}
                    </ul>
                  </MenuWrapper>
                </div>
                {/* 내용 부분 */}
                <div
                  className="col-md-12 col-lg-10 pl-sm-30"
                  style={{ minHeight: "30rem" }}
                >
                  {children}
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default CSBoard;
